// react
import { forwardRef } from 'react';

// tanstack
import { Link } from '@tanstack/react-router';

// material ui icons
import EditRoundedIcon from '@mui/icons-material/EditRounded';

// material ui
import Button, { type ButtonProps } from '@mui/material/Button';

export type EditButtonLinkProps = Omit<ButtonProps<typeof Link>, 'variant'>;

/**
 * Reusable "edit" action button.
 *
 * Thin wrapper around MUI `Button` that fixes `variant="contained"` and
 * defaults a leading `EditRoundedIcon`, making edit actions visually
 * consistent and explicit in markup. Defaults `component` to the router's
 * `Link`, since "edit" actions typically navigate to an edit route (e.g.
 * `to="edit"`).
 */
export const EditButtonLink = forwardRef<
  HTMLAnchorElement,
  EditButtonLinkProps
>(({ startIcon = <EditRoundedIcon />, component = Link, ...rest }, ref) => (
  <Button
    ref={ref}
    component={component}
    variant="contained"
    startIcon={startIcon}
    {...rest}
  />
));

EditButtonLink.displayName = 'EditButtonLink';
